import appConfig from 'appConfig';
import t from 'common/i18n';
import GridHeader from '../GridHeader';
import FolderItem from '../FolderItem';
import FileItem from '../FileItem';

const TOTAL_PAGE_SIZE = appConfig.google.drive.pageSize;
const FOLDER_HEIGHT = 58;
const FILE_HEIGHT = 170;

const GRID_TYPES = {
  FOLDERS: 'folders',
  FILES: 'files',
};

const renderHeader = (itemProps) => (itemProps.total ? <GridHeader>{t(`google_drive.grid.${itemProps.type}`)}</GridHeader> : null);

const renderGridItem = (itemProps, index) => {
  const item = itemProps.items[index];
  const isLoading = !item && index < itemProps.total;

  const isSelected = !!(item && itemProps.selected && ~itemProps.selected.indexOf(item.id));

  return item || isLoading ? (
    itemProps.type === GRID_TYPES.FOLDERS ? (
      <FolderItem {...item} isLoading={isLoading} isSelected={isSelected} />
    ) : (
      <FileItem {...item} isLoading={isLoading} isSelected={isSelected} isMultiple={itemProps.isMultiple} />
    )
  ) : null;
};

const getTopSection = (type, items, total) => ({
  isRowItem: true,
  itemHeight: items.length ? 50 : 1,
  isItemLoaded: true,
  renderItemComponent: renderHeader,
  itemProps: {
    type,
    total,
  },
});

const loadMoreItems = (action, isPending, cursor, params) =>
  new Promise((resolve) => {
    // TODO: This will cause missing requests !!!!!!!!
    // TODO: NEED to move into requests queue

    if (!isPending) {
      const actionParams = params.term
        ? {
            term: params.term,
          }
        : {
            id: params.folderId,
            kind: params.folderKind,
            driveId: params.folderDriveId,
            path: params.folderPath,
          };

      action({
        ...actionParams,
        sort: params.sort,
        orderBy: params.orderBy,
        cursor,
      });
    }

    // TODO - this is resolved immediately!!!!!!!! should be resolved on fetch!!!!

    resolve();
  });

export { TOTAL_PAGE_SIZE, FOLDER_HEIGHT, FILE_HEIGHT, GRID_TYPES, getTopSection, renderGridItem, loadMoreItems };
